import CenteredGraySection from "./CenteredGraySection";

export default CenteredGraySection;